import { Button } from "../../../components/ui/button";

interface FiltersResetButtonProps {
    handleRefresh: () => void;
    disabled?: boolean;
}

/**
 * FiltersResetButton Component
 *
 * Button to reset all applied filters in a report.
 * Displays filter X icon with "Reset Filtre" text.
 *
 * @param handleRefresh - Function to call when filters should be reset
 * @param disabled - Whether the button should be disabled
 */
export default function FiltersResetButton({ handleRefresh, disabled }: FiltersResetButtonProps) {
    return (
        <Button onClick={handleRefresh} disabled={disabled} className="w-full sm:w-auto">
            Reset Filtre
        </Button>
    );
}
